import React from "react";
import * as APIModels from "../../models";
import { Alert, Stack } from "@mui/material";

type LogResultsParams = {
    logs: Array<APIModels.MatterLogResponse>;
};

type LogResultParam = {
    log: APIModels.MatterLogResponse;
};

const SuccessfulLogResult = (params: LogResultParam) => {
    return <Alert severity="success">{params.log.log}</Alert>;
};
const InfoLogResult = (params: LogResultParam) => {
    return <Alert severity="info">{params.log.log}</Alert>;
};
const WarningLogResult = (params: LogResultParam) => {
    return <Alert severity="warning">{params.log.log}</Alert>;
};
const ErrorLogResult = (params: LogResultParam) => {
    return <Alert severity="error">{params.log.log}</Alert>;
};

const LogResults = (params: LogResultsParams) => {
    return (
        <Stack direction="column" sx={{ width: "100%" }} spacing={4}>
            {params.logs.map<React.ReactElement>((log) => {
                switch (log.severity) {
                    case 1:
                        return <SuccessfulLogResult log={log} />;
                    case 2:
                        return <InfoLogResult log={log} />;
                    case 3:
                        return <WarningLogResult log={log} />;
                    case 4:
                        return <ErrorLogResult log={log} />;
                    default:
                        return <></>;
                }
            })}
        </Stack>
    );
};

export default LogResults;
